import { useEffect, useRef } from 'react';

import { useAppDispatch, useAppSelector } from 'features/app/hooks';
import {
  autoLaunchDialPadSelector,
  isDialPadOpenedSelector,
  toggleDialPad,
} from 'features/dial-pad/store/';

export function useAutoLaunchDialPad() {
  const dispatch = useAppDispatch();
  const autoLaunchDialPad = useAppSelector(autoLaunchDialPadSelector);
  const isDialPadOpened = useAppSelector(isDialPadOpenedSelector);
  const hasAutoLaunchEffectRun = useRef(false);

  useEffect(() => {
    if (
      !hasAutoLaunchEffectRun.current &&
      autoLaunchDialPad &&
      !isDialPadOpened
    ) {
      dispatch(toggleDialPad());
    }
    hasAutoLaunchEffectRun.current = true;
  }, [autoLaunchDialPad, isDialPadOpened, dispatch]);
}
